import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

// 2026-08-23 cn — tailwind-merge + clsx, verified 2026 best practice
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
